export default {
  namespaced: true,
  state: {
    pagination: {
      rowsPerPage: Number.parseInt(localStorage.getItem('tokens/rowsPerPage')) || 5
    }
  },
  mutations: {
    pagination(state, pagination) {
      state.pagination = pagination;
      localStorage.setItem('tokens/rowsPerPage', pagination.rowsPerPage);
    }
  },
  actions: {
    setPagination(context, pagination) {
      context.commit('pagination', pagination);
    }
  }
};
